import { isOrganization } from "@/share/validateOrganization";

export const MEMBER_ROLES = ["MEMBER", "MEMBERSHIP_USER"];

const getHeadOfficeId = (user) => {
  if (!user) return null;

  if (user.headOffice && typeof user.headOffice === "object") {
    return user.headOffice._id || user.headOffice.id || null;
  }

  return user.headOffice || null;
};

export const isAmpiMember = (user) => {
  if (!user || !MEMBER_ROLES.includes(user.role)) return false;

  return isOrganization(
    "ampi",
    user._id,
    getHeadOfficeId(user),
    user.organization
  );
};

